import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-service-definition-step',
  templateUrl: './service-definition-step.component.html',
  styleUrl: './service-definition-step.component.scss',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslocoModule]
})
export class ServiceDefinitionStepComponent {
  @Input() active = false;
  @Input() completed = false;
  @Input() version?: string;
}
